export default __webpack_public_path__ + "static/media/3.314bfab0.webp";